module.exports = __webpack_public_path__ + "static/media/star.197531c2.svg";